module.exports = __webpack_public_path__ + "img/banner-bg1.c8e7f324.jpg";